import { merge, Text } from '@fluentui/react';
import React, { useMemo } from 'react';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';

const Title = () => {

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                title: {
                    root: {
                        color: "white",
                        fontSize: 18,
                        fontWeight: 700,
                        margin: 0,
                        minHeight: 132,
                        lineHeight: "22px",
                        width: 222,
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        title: {
                            root: {
                                fontSize: 35,
                                lineHeight: "42px",
                                textAlign: "center",
                                width: 857,
                            }
                        },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Text as="h1" styles={styles.title}>
        Pour vous accompagner de A à Z dans votre projet immobilier, votre Espace Personnel sécurisé
        {responsiveSize === ResponsiveSize.small ? <br /> : " "}
        est accessible 24h/24, 7j/7 et gratuit !
    </Text>;

};

export default Title;